import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import {
  Container,
  ContainerRequisitos,
  ContainerSenha,
  IconVisible,
  InputSenha
} from "./senha.styles";
import { AiFillEye } from "react-icons/ai";
import { AiFillEyeInvisible } from "react-icons/ai";

interface SenhaProps {
  initialPassword?: { password: string; confirmPassword: string };
  validaSenha: Dispatch<SetStateAction<boolean>>;
  senhaAtual: Dispatch<SetStateAction<any>>;
}

const NewSenhaComponent: React.FC<SenhaProps> = ({
  validaSenha,
  senhaAtual,
  initialPassword,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [newPassword, setNewPassword] = useState({
    password: initialPassword?.password ?? "",
    confirmPassword: initialPassword?.confirmPassword ?? "",
    openModalNewPassword: false,
  });

  const [possuiMinimoCaracteres, setPossuiMinimoCaracteres] = useState(false);
  const [possuiNumero, setPossuiNumero] = useState(false);
  const [possuiMinuscula, setPossuiMinuscula] = useState(false);
  const [possuiMaiuscula, setPossuiMaiuscula] = useState(false);
  const [senhasIguais, setSenhasIguais] = useState(false);

  useEffect(() => {
    // const regexLetraMaiuscula = /[A-Z]/.test(senhaValida); //caso futuramente precise

    setPossuiMinimoCaracteres(/.{8,}/.test(newPassword.password));
    setPossuiNumero(/\d/.test(newPassword.password));
    setPossuiMinuscula(/[a-z]/.test(newPassword.password));
    setPossuiMaiuscula(/[A-Z]/.test(newPassword.password));
    setSenhasIguais(
      newPassword.password === newPassword.confirmPassword &&
        newPassword.password !== ""
    );

    if (
      possuiMinimoCaracteres &&
      possuiNumero &&
      possuiMinuscula &&
      possuiMaiuscula &&
      senhasIguais
    ) {
      senhaAtual(newPassword);
      return validaSenha(true);
    } else {
      senhaAtual(newPassword);
      return validaSenha(false);
    }
  }, [
    possuiMinimoCaracteres,
    possuiNumero,
    possuiMinuscula,
    possuiMaiuscula,
    senhasIguais,
    newPassword,
  ]);

  return (
    <Container>
      <ContainerSenha>
        <ContainerRequisitos>
          <strong>Requisitos da senha</strong>
          <ul style={{ listStyleType: "disc", textAlign: "left" }}>
            <li style={{ color: possuiMinimoCaracteres ? "#15803d" : "#b91c1c" }}>8 caracteres</li>
            <li style={{ color: possuiNumero ? "#15803d" : "#b91c1c" }}>1 número</li>
            <li style={{ color: possuiMinuscula ? "#15803d" : "#b91c1c" }}>1 letra minúscula</li>
            <li style={{ color: possuiMaiuscula ? "#15803d" : "#b91c1c" }}>1 letra maiúscula</li>
            <li style={{ color: senhasIguais ? "#15803d" : "#b91c1c" }}>Senhas iguais</li>
          </ul>
        </ContainerRequisitos>

        <InputSenha>
          <input
            type={showPassword ? "text" : "password"}
            className="input-login"
            placeholder="Nova senha"
            value={newPassword.password}
            onChange={(e) => {
              setNewPassword((prevState: any) => ({
                ...prevState,
                password: e.target.value,
              }));
            }}
          />
          <IconVisible
            aria-label={showPassword ? "Ocultar senhas" : "Mostrar senhas"}
            title={showPassword ? "Ocultar senhas" : "Mostrar senhas"}
            onClick={() => setShowPassword((visible) => !visible)}
          >
            {showPassword ? (
              <AiFillEyeInvisible aria-hidden="true" />
            ) : (
              <AiFillEye aria-hidden="true" />
            )}
          </IconVisible>
        </InputSenha>

        <InputSenha>
          <input
            type={showPassword ? "text" : "password"}
            className="input-login"
            placeholder="Confirmar nova senha"
            value={newPassword.confirmPassword}
            onChange={(e) => {
              setNewPassword((prevState: any) => ({
                ...prevState,
                confirmPassword: e.target.value,
              }));
            }}
          />
          <IconVisible
            aria-label={showPassword ? "Ocultar senhas" : "Mostrar senhas"}
            title={showPassword ? "Ocultar senhas" : "Mostrar senhas"}
            onClick={() => setShowPassword((visible) => !visible)}
          >
            {showPassword ? (
              <AiFillEyeInvisible aria-hidden="true" />
            ) : (
              <AiFillEye aria-hidden="true" />
            )}
          </IconVisible>
        </InputSenha>
      </ContainerSenha>
    </Container>
  );
};

export default NewSenhaComponent;
